var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"value":_vm.avance,"color":_vm.color,"height":"20","rounded":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_c('strong',{staticClass:"white--text"},[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }